import * as Scrivito from "scrivito";

function getHomepage(currentPage) {
  if (!currentPage) {
    return null;
  }

  const siteId = currentPage.siteId();
  const breadcrumb = [...currentPage.ancestors(), currentPage]
    .filter((n) => n)
    .reverse();
  const nextHomepage = breadcrumb.find((obj) => obj.objClass() === "Homepage");
  if (nextHomepage) {
    return nextHomepage;
  }
  return Scrivito.Obj.onSite(siteId).root();
}

export default getHomepage;
